/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useState } from "react";
import { DateRange } from "~/components/Charts";
import { EstatePeriod } from "~/constants";
import { useBillingPeriod } from "~/services/customers";

type Props = {
  onChange: (selectedPeriod: EstatePeriod, selectedRange?: DateRange) => void;
  clearRange: () => void;
};

export function usePeriodSelector({ onChange, clearRange }: Props) {
  const defaultRangeLabel = "Date Range";
  const { isPreviousBillingPeriod } = useBillingPeriod();

  const [rangeLabel, setRangeLabel] = useState(defaultRangeLabel);

  const setRange = (selectedRange: DateRange | undefined) => {
    onChange(EstatePeriod.RANGE, selectedRange);
  };

  const handleClear = () => {
    clearRange();
    setRangeLabel(defaultRangeLabel);
    onChange(mapEstatePeriod(isPreviousBillingPeriod));
  };

  const onPeriodChange = (selectedPeriod: EstatePeriod) => {
    onChange(selectedPeriod);
  };

  return {
    rangeLabel,
    setRangeLabel,
    setRange,
    handleClear,
    onPeriodChange,
  };
}

function mapEstatePeriod(isPreviousBillingPeriod: boolean) {
  return isPreviousBillingPeriod
    ? EstatePeriod.PREVIOUS_MONTH
    : EstatePeriod.DEFAULT_MONTH;
}
